var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnrollment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9013 19.7537L47.698 3.60621L10.1449 9.31233C4.4902 10.1716 0.718066 15.3453 1.59931 20.8574L12.6673 90.0874C13.5486 95.5996 18.7423 99.3177 24.397 98.4585L60.0195 93.0457L79.6268 51.2641L75.3078 24.2491L52.9013 19.7537Z",
    fill: "#82C4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7017 3.62914L75.238 24.2597L59.486 26.6532C55.1114 27.3179 51.0236 24.4074 50.3417 20.1426L47.7017 3.62914Z",
    fill: "#03447D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35.7475,
    height: 5.81538,
    rx: 1,
    transform: "matrix(0.988652 -0.150224 0.157868 0.98746 17.1182 49.4265)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 25.8176,
    height: 5.81538,
    rx: 1,
    transform: "matrix(0.988652 -0.150224 0.157869 0.98746 20.4844 70.4822)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16.8807,
    height: 5.81537,
    rx: 1,
    transform: "matrix(0.988652 -0.150224 0.157869 0.98746 22.1675 81.0099)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 45.6773,
    height: 5.81538,
    rx: 1,
    transform: "matrix(0.988652 -0.150224 0.157868 0.98746 18.8013 59.9543)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5158 51.6181C91.0934 53.2005 99.9999 62.8816 99.9999 74.6002C99.9999 87.4109 89.338 97.802 76.1921 97.802C67.1546 97.802 59.2744 92.8887 55.2593 85.6461C53.4295 82.3525 52.3838 78.5859 52.3838 74.5823C52.3838 61.7716 63.0462 51.381 76.1921 51.381C77.3128 51.3994 78.414 51.4725 79.5158 51.6181Z",
    fill: "#03447D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6449 74.154L78.0828 82.239V62.3086C78.0828 61.305 77.2549 60.4832 76.2427 60.4832C75.2309 60.4832 74.403 61.305 74.403 62.3086V82.239L66.7857 74.154C66.0864 73.424 64.9088 73.3686 64.1729 74.0623C63.4369 74.756 63.3822 75.9062 64.0804 76.6362L74.8446 88.1158C75.1937 88.4811 75.6725 88.6999 76.1874 88.6999C76.7023 88.6999 77.1806 88.4811 77.5307 88.1158L88.2938 76.6362C88.9931 75.9062 88.9559 74.7381 88.22 74.0623C87.4851 73.3686 86.3442 73.424 85.6449 74.154Z",
    fill: "#82C4FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrollment);
export default __webpack_public_path__ + "static/media/enrollment.dba314d3b25481233e72866bdedc161c.svg";
export { ForwardRef as ReactComponent };